import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, rpcCrudService, addOnInvalidateHandler, invalidateResource } from 'kea-resource';

const controller = rpcController("ViajesEAD");

export const ViajeEAD = cacheResource({
        /**Crea un viaje de EAD y devuelve el id */
        CrearViaje: async (model: models.NuevoViajeEADModel): Promise<number> => await controller('CrearViaje', {}, model),

        /**Le da salida/inicio a un viaje de EAD, este debe de estar iniciado en la app movil */
        DarSalidaViaje: async (idViaje: number): Promise<void> => await controller('DarSalidaViaje', { idViaje }),

          /**Marca como finalizado pero pendiente de descarga un viaje, este paso se hace despues de que el chofer lo finalizó desde su app  */
        MarcarFinalizadoPendienteDescarga: async (idViaje: number): Promise<void> => await controller('MarcarFinalizadoPendienteDescarga', {idViaje}), 

        /**Marca un viaje como pendiente de verificación, este paso se hace despues de descargar por completo el camión de EAD */
        MarcarPendienteVerificacion: async (idViaje: number): Promise<void> => await controller('MarcarPendienteVerificacion', {idViaje}), 

        /**Marca un viaje como finalizado */
        FinalizarViaje: async (idViaje: number): Promise<void> => await controller('FinalizarViaje', {idViaje}), 

        /**
         * Cancela un viaje de EAD
         * @param idViaje 
         */
        CancelarViaje: async (idViaje: number): Promise<void> => await controller('CancelarViaje', { idViaje }),

        /**Consulta un listado de viajes */
        ConsultarViajes: async (filtro: models.FiltroViajeEAD): Promise<models.ViajeEADDto[]> => await controller('ConsultarViajes', {}, filtro),

        /**Para cierto usuario obtiene un listado con los posibles viajes que el podria iniciar en su dispositivo */
        ObtenerPosiblesInicioApp: async (idUsuario: number): Promise<models.ViajeEADDto[]> => await controller('ObtenerPosiblesInicioApp', { idUsuario }),

        /**Imprime los acuses internos de las guias incluidas en este viaje */
        ReporteAcusesInternos: async (idViajeEAD: number): Promise<string> => await controller('ReporteAcusesInternos', { idViajeEAD }),

        /**Obtiene el DTO de un viaje de EAD */
        GetViaje: async (idViajeEAD: number): Promise<models.ViajeEADDto> => await controller('GetViaje', { idViajeEAD }),

        /**Obtiene un listado con las guias del viaje */
        GetGuiasEnViaje: async (idViajeEAD: number): Promise<models.GuiaDTO[]> => await controller('GetGuiasEnViaje', { idViajeEAD }),

        /**Obtiene el reporte de manifiesto de viaje de EAD */
        ReporteManifiesto: async (idViajeEAD: number, esDeSalida: boolean): Promise<string> => await controller('ReporteManifiesto', { idViajeEAD, esDeSalida }),

             /**Obtiene el modelo de verificación de un viaje de EAD. Este modelo contiene la información para que el usuario verifique el viaje de EAD */
        ObtenerModeloVerificacionViaje: async (idViajeEAD: number): Promise<models.VerificacionViajeEADDto> => await controller('ObtenerModeloVerificacionViaje', {idViajeEAD}), 

        /**Crea las guias de los acuses entregados en un viaje de EAD. Devuelve la cantidad de guias de acuse que se generaron */
        CrearGuiasAcuse: async (idViaje: number): Promise<number> => await controller('CrearGuiasAcuse', {idViaje}), 
}, {
                ConsultarViajes: true,
                GetGuiasEnViaje: true
        }, {
                CrearViaje: true,
                MarcarFinalizadoPendienteDescarga: true,
                MarcarPendienteVerificacion: true,
                FinalizarViaje: true,
                DarSalidaViaje: true,
                CancelarViaje: true
        });


// WEBPACK FOOTER //
// ./app/resources/items/viajeead.tsx